import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

import LoginPage from '../container/loginPage/LoginPage';
import RegistryPage from '../container/FreeTrial/Register';
import Step1 from '../container/FreeTrial/Step1';
/* import Confirmation from '../container/FreeTrial/Confirmation'; */

export default (props) => (
  <>
    <Router>
      <Switch>
        <Route exact path='/'> <LoginPage /> </Route>
        <Route exact path='/register-trial'><RegistryPage /></Route>
        <Route exact path='/register-trial/form'><Step1 /></Route>
        {/* <Route exact path='/register-trial/confirmation'><Confirmation /></Route> */}
        <Redirect from='*' to='/' />
      </Switch>
    </Router>
  </>
);